import { isEmpty } from 'lodash-es'

import { commonUtils } from '@sunrise/shared'

import featureToggle from '../featureToggle'
import { Estate } from '../service/realEstateService.interface'
import { DecoratedEstate } from './decoratedItemEstate.interface'

export function decoratedItemsOf(estates?: Estate[], baseUrl?: string): DecoratedEstate[] {
    if (isEmpty(estates) || !estates) {
        return []
    }
    return estates.map((estate, index) => ({
        address: buildAddress(estate.geoDataVisible, estate.city, estate.street),
        city: estate.city,
        commercialExpose: estate.commercialExpose,
        createdDateFormatted: estate.createdDateFormatted,
        detailUrl: buildDetailUrl(estate, baseUrl),
        geoDataVisible: estate.geoDataVisible,
        equipmentAsString: estate.equipmentAsString,
        exposeeId: estate.exposeeId,
        imageCount: estate.imageCount,
        landArea: estate.landArea,
        landAreaText: estate.landAreaText,
        livingArea: estate.livingArea,
        livingAreaText: estate.livingAreaText,
        newestEstate: estate.newestEstate,
        ownInventory: estate.ownInventory,
        position: index + 1,
        postcode: estate.postcode,
        price: buildPriceText(estate.priceRaw, estate.squareMeterPrice),
        priceRaw: estate.priceRaw,
        priceAppendix: estate.priceAppendix,
        priceType: estate.priceType,
        providerBadgeText: buildBadgeText(estate.commercialExpose),
        rooms: estate.rooms,
        smallImageUrl: estate.smallImageUrl,
        squareMeterPrice: estate.squareMeterPrice,
        status: estate.status,
        street: estate.street,
        title: estate.title,
    }))
}

function choosePrice(priceRaw?: number, squareMeterPrice?: number) {
    return squareMeterPrice || priceRaw
}

function buildPriceText(priceRaw?: number, squareMeterPrice?: number): string {
    const price = choosePrice(priceRaw, squareMeterPrice)
    return price ? `${commonUtils.thousandSeparator(price)} €` : 'k.A'
}

function buildAddress(geoDataVisible: boolean, city: string, street?: string): string {
    if (geoDataVisible && street) {
        return `${city}, ${street}`
    }

    return city
}

function buildBadgeText(isCommercialExpose: boolean) {
    return `${isCommercialExpose ? 'Gewerblicher' : 'Privater'} Anbieter`
}

function buildDetailUrl(estate: Estate, baseUrl?: string): string {
    if (!baseUrl || !featureToggle.isLiveApi) {
        return estate.detailUrl
    }

    const id = estate.iframeUrl ? `iw-${estate.exposeeId}` : estate.exposeeId

    return `${baseUrl}/${id}`
}
